import React from "react";
import { useEffect } from "react";
import { AuthRestartButton } from "../misc/restart-button.component";
import { AuthPaymentContainer } from "../misc/auth-payment-container.component";
import { AuthContinue } from "../misc/auth-continue.component";
import { ReviewDisplayField } from "../misc/review-display-field.component";
import Show from "../../../utils/show.component";
import getPaymentDay from "../misc/get-payment-day";
import { OpenEndRecurringDisclosure } from "../misc/disclosures";
import { generateLoanDescription } from "../misc/messaging-utils";

export const AuthRecurringOpenEndReview = (props) => {
  const advance = () => {
    window.scrollTo(0, 0);
    props.callAuthSubmitPayment();
  };

  useEffect(() => {
    // If the payment response has this property, that means there were no errors
    // submitting the payment and the paymentResponse property has been set
    if (props.paymentResponse.hasOwnProperty("AmountDue")) {
      props.continue();
    }
  }, [props.paymentResponse]);

  return (
    <AuthPaymentContainer title="Review & Submit">
      <div className="text-centered bold f20">
        {`${generateLoanDescription(props.selectedLoan, true)}`}
      </div>
      <div className="my-4 divider"></div>
      <div>
        <Show condition={props.openEndPaymentType !== "Fixed Amount"}>
          <ReviewDisplayField
            title={"Payment Method"}
            value={props.openEndPaymentType}
            valueClassNames={"minwidth-fit"}
            titleColumnSize={"col-md-5"}
            valueColumnSize={"col-md-7"}
          />
        </Show>
        <ReviewDisplayField title={"First Payment Date"} value={props.firstPaymentDate} />
        <ReviewDisplayField title={"Payment Frequency"} value={props.paymentFrequency} />
        <ReviewDisplayField
          title={"Payment Day"}
          value={getPaymentDay(props.paymentFrequency, props.firstPaymentDate)}
        />
        <ReviewDisplayField
          title={"Payment Account"}
          value={`Ending in ${props.paymentAccount}`}
          valueClassNames={"minwidth-fit"}
        />
        <Show condition={props.openEndPaymentType === "Fixed Amount"}>
          <ReviewDisplayField title={"Payment Amount"} value={props.paymentAmount} />
        </Show>
      </div>
      {OpenEndRecurringDisclosure(props.isInternalTransfer)}
      <AuthContinue
        type="button"
        title="Submit Payment"
        onClickFunction={() => advance()}
      />
      <AuthRestartButton backToLoans={props.backToLoans} />
    </AuthPaymentContainer>
  );
};



// WEBPACK FOOTER //
// ./src/components/authenticated-payments/review/auth-recurring-open-end-review-fields.component.js